<mat-tab-group class="tab-group" animationDuration="0ms">
  <mat-tab [label]=" 'authorization.title' | translate ">
    <app-login></app-login>
  </mat-tab>
  <mat-tab [label]=" 'authorization.registration' | translate ">
    <app-registration></app-registration>
  </mat-tab>
</mat-tab-group>
